// extracted by mini-css-extract-plugin
module.exports = {"checkboxReplacement":"OrderControl_checkboxReplacement__1_5Bd"};